let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kb7EK")).then(() => parcelRequire('jdcIw'));